import { ConfigProvider } from './../../providers/config-provider';
import { Subscription } from 'rxjs/rx';
import { Keyboard } from '@ionic-native/keyboard';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
//Providers
import { UtilProvider } from '../../providers/util-provider';
//Models
import { Congresso } from '../../models/congresso.model';

@Component({
  selector: 'page-expositor-video',
  templateUrl: 'expositor-video.html'
})
export class ExpositorVideoPage {

  public id: number;
  public titleVideo: string;
  public urlVideo: any;
  public congresso: Congresso;
  public videoId: string;
  public videoType: string;
  public isCurrent: boolean;
  public titlePage: string;

  private onShowSubscription: Subscription;
  private onHideSubscription: Subscription;

  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public utilProvider: UtilProvider,
    public configProvider: ConfigProvider,
    private navParams: NavParams,
    private keyboard: Keyboard) {
      this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
      this.isCurrent = this.congresso.Ano == this.configProvider.ANO_ATUAL || this.congresso.Liberado;
      this.id = this.navParams.get("id");
      this.urlVideo = this.navParams.get("urlVideo");
      this.titleVideo = this.navParams.get("titleVideo");
      this.titlePage = this.navParams.get("titlePage");
  }

  ionViewDidEnter() {
    this.keyboard.disableScroll(true);
    let appEl = <HTMLElement>(document.getElementsByTagName('ION-APP')[0]),
        appElHeight = appEl.clientHeight;

    this.onShowSubscription =  this.keyboard.onKeyboardShow().subscribe((e) => {
        appEl.style.height = ((appElHeight) - (<any>e).keyboardHeight) + 'px';
    });

    this.onHideSubscription = this.keyboard.onKeyboardHide().subscribe((e) => {
        appEl.style.height = '100%';
    });
  }

  dismiss() {
    let appEl = <HTMLElement>(document.getElementsByTagName('ION-APP')[0]),
        appElHeight = appEl.clientHeight;
        appEl.style.height = '100%';
      this.keyboard.disableScroll(false);
      this.onShowSubscription.unsubscribe();
      this.onHideSubscription.unsubscribe();
      this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/expositor-video/expositor-video.ts